import { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import QrScanner from 'qr-scanner';

const QRReader = forwardRef(({
    onScanSuccess = () => { },
    containerStyles = {}
}, ref) => {
    const videoRef = useRef(null);
    const [scanner, setScanner] = useState(null);

    useEffect(() => {
        if (!videoRef.current) return;

        const qrScanner = new QrScanner(
            videoRef.current,
            (result) => {
                onScanSuccess(result.data);
            },
            {
                returnDetailedScanResult: true,
                highlightScanRegion: true,
            }
        );

        setScanner(qrScanner);
        qrScanner.start().catch((err) => console.error("Scanner start failed:", err));

        return () => {
            qrScanner.stop();
            qrScanner.destroy();
        };
    }, []);

    useImperativeHandle(ref, () => ({
        start: () => scanner?.start(),
        stop: () => scanner?.stop(),
    }));

    return (
        <div style={containerStyles}>
            <video
                ref={videoRef}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transform: "scaleX(-1)",
                }}
            />
        </div>
    );
});

export default QRReader;